import { graphqlRequest } from '../../../utils/graphqlRequest';

export const PARSE_SUPPLIER_CATALOG = `
  mutation ParseSupplierCatalog($parseSupplierCatalogInput: ParseSupplierCatalogInput!) {
    parseSupplierCatalog(parseSupplierCatalogInput: $parseSupplierCatalogInput) {
      name
      perItemCost
      unit
      category
      quantity
    }
  }
`;

export const IMPORT_SUPPLIER_CATALOG = `
  mutation ImportSupplierCatalog($supplierId: String!, $products: [CatalogProductInput!]!) {
    importSupplierCatalog(supplierId: $supplierId, products: $products) {
      created
      merged
      failed
    }
  }
`;

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const s = String(reader.result || '');
      const comma = s.indexOf(',');
      resolve(comma >= 0 ? s.slice(comma + 1) : s);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function toCatalogProducts(rows) {
  return (rows || [])
    .filter((r) => r.selected && String(r.name || '').trim())
    .map((r) => ({
      name: String(r.name).trim(),
      perItemCost: Number(r.perItemCost) || 0,
      unit: r.unit || 'Each',
      category: r.category || 'Consumable',
      quantity: Number(r.quantity) || 0,
    }));
}

export async function parseCatalogFromFile(file) {
  const lower = String(file?.name || '').toLowerCase();
  if (lower.endsWith('.doc') && !lower.endsWith('.docx')) {
    throw new Error(
      'Save the Word file as .docx (File → Save As → Word Document).',
    );
  }
  let payload;
  if (lower.endsWith('.docx') || lower.endsWith('.doc')) {
    payload = {
      fileBase64: await fileToBase64(file),
      fileName: file.name,
    };
  } else {
    payload = { text: await file.text(), fileName: file.name };
  }
  const data = await graphqlRequest(
    PARSE_SUPPLIER_CATALOG,
    { parseSupplierCatalogInput: payload },
    { timeout: 120000 },
  );
  const parsed = Array.isArray(data?.parseSupplierCatalog)
    ? data.parseSupplierCatalog
    : [];
  return parsed.map((r, i) => ({
    ...r,
    key: `${i}-${r.name}`,
    selected: true,
  }));
}

export async function importCatalogProducts(supplierId, rows) {
  const products = toCatalogProducts(rows);
  if (!products.length) return { created: 0, merged: 0, failed: 0, skipped: true };
  const data = await graphqlRequest(
    IMPORT_SUPPLIER_CATALOG,
    { supplierId, products },
    { timeout: 180000 },
  );
  return data?.importSupplierCatalog || { created: 0, merged: 0, failed: 0 };
}
